// extracted by mini-css-extract-plugin
export default {"content":"infoIconModal_content__9xkuP","content--text":"infoIconModal_content--text__z+3M1"};